import React from "react";

import Navbar from "../../components/modules/Navbar";
import "./sportsStyles.css";
import images from "../../components/function/SportsImages";
import { useEffect, useState, useRef } from "react";
import "../../components/function/CustomCursor.css";
import { AiFillCloseCircle } from "react-icons/ai";
import { BsBookFill } from "react-icons/bs";
import Footer from "../../components/modules/Footer";
import { BsFileArrowDown } from "react-icons/bs";
import { Link as LinkScroll } from "react-scroll";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { useTranslation } from "react-i18next";
import Modal from "@mui/material/Modal";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const Sports = () => {
  const { t } = useTranslation("common");

  const [isShowCard, setShowCard] = useState(false);

  const titleRef = useRef();
  const onLoad = () => {
    gsap
      .timeline()
      .fromTo(
        ".letter",
        {
          x: -100,
          opacity: 0,
        },
        {
          x: 0,
          opacity: 1,
          stagger: 0.33,
          delay: 0.3,
        }
      )
      .to(".letter", {
        margin: "0 1vw",
        delay: 0.8,
        duration: 0.5,
      })
      .to(".letter", {
        margin: "0",
        delay: 0.8,
        duration: 0.5,
      });
  };

  useEffect(() => {
    onLoad();
  }, []);

  const HideCard = () => setShowCard(false);

  const [open, setOpen] = React.useState(false);
  const [genre, setGenre] = React.useState("M");
  const [cheer, setCheer] = React.useState("C");
  const handleOpen = (id) => {
    setOpen(id);
  };
  const handleClose = () => {
    setOpen(null);
    setGenre("M");
  };

  return (
    <div>
      <Navbar scroll="false" color="transparent" />
      <div className="sports">
        <div className="sports-home">
          <div className="sport-title">
            <h1 id="title" ref={titleRef}>
              <span className="letter">{t("sports.1")}</span>
              <span className="letter">{t("sports.2")}</span>
              <span className="letter">{t("sports.3")}</span>
              <span className="letter"> </span>
              <span className="letter">S</span>
              <span className="letter">P</span>
              <span className="letter">O</span>
              <span className="letter">R</span>
              <span className="letter">T</span>
              <span className="letter">S</span>
            </h1>
            <h3> Edition 2026</h3>
          </div>

          <LinkScroll
            to="sports-scroll"
            smooth={true}
            offset={-10}
            duration={1000}
          >
            {" "}
            <BsFileArrowDown
              style={{ color: "white" }}
              className="fleche-mazars"
            />
          </LinkScroll>
          <div className="vague">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path
                fill="#ffffff"
                fillOpacity="1"
                d="M0,288L60,288C120,288,240,288,360,266.7C480,245,600,203,720,208C840,213,960,267,1080,288C1200,309,1320,299,1380,293.3L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
              ></path>
            </svg>
          </div>
        </div>
        <div className="sports-scroll" id="sports-scroll">
          <div className="sports-content">
            <div className="sports-content-margin">
              {images.map((image) => (
                <div key={image.id} className="sports-content-images">
                  <img  src={image.src} alt="" />
                  <div className="image-overlay">
                    <div className="image-title">{image.title}</div>
                    <button
                      className="image-button"
                      onClick={() => handleOpen(image.id)}
                    >
                      Voir les détails
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {images.map((image) => {
        return (
          <React.Fragment>
            <Modal
              open={open === image.id}
              onClose={handleClose}
              aria-labelledby="parent-modal-title"
              aria-describedby="parent-modal-description"
              style={{ zIndex: 100000000 }}
            >
              <div className="modal-box">
                <h2 id="parent-modal-title">{image.title}</h2>
                {image.sportFM === 1 && image.id !== 5 ? (
                  <div className="modal-genre">
                    <button
                      onClick={() => setGenre("M")}
                      className={genre === "M" ? "modal-genre-selected" : ""}
                    >
                      {" "}
                      Masculin
                    </button>
                    <button
                      onClick={() => setGenre("F")}
                      className={genre === "F" ? "modal-genre-selected" : ""}
                    >
                      {" "}
                      Féminin
                    </button>
                  </div>
                ) : image.id === 5 ? (
                  <div className="modal-genre">
                    <button
                      onClick={() => setCheer("C")}
                      className={cheer === "C" ? "modal-genre-selected" : ""}
                    >
                      {" "}
                      Cheer
                    </button>
                    <button
                      onClick={() => setCheer("P")}
                      className={cheer === "P" ? "modal-genre-selected" : ""}
                    >
                      {" "}
                      Pom Pom
                    </button>
                  </div>
                ) : (
                  <></>
                )}

                <div className="modal-content">
                  <h3> Description</h3>
                  <p id="parent-modal-description">
                    {image.id !== 5
                      ? genre === "M"
                        ? image.description
                        : image.description2
                      : ""}
                    {image.id === 5
                      ? cheer === "C"
                        ? image.description
                        : image.description2
                      : ""}
                  </p>
                </div>
                <div className="modal-content-contact">
                  <h3> Contact</h3>
                  {image.id !== 5 ? (
                    genre === "M" ? (
                      <div className="modal-content-row">
                        <p>{image.contact}</p>
                        <p>{image.numero}</p>
                        <p>{image.mail}</p>
                      </div>
                    ) : (
                      <div className="modal-content-row">
                        <p>{image.contact2}</p>
                        <p>{image.numero2}</p>
                        <p>{image.mail2}</p>
                      </div>
                    )
                  ) : (
                    <>
                      <div className="modal-content-row">
                        <p>{image.contact}</p>
                        <p>{image.numero}</p>
                        <p>{image.mail}</p>
                      </div>

                      <div className="modal-content-row">
                        <p>{image.contact2}</p>
                        <p>{image.numero2}</p>
                        <p>{image.mail2}</p>
                      </div>
                    </>
                  )}
                </div>
                {image.id !== 5 ? (
                  <div className="modal-content-button">
                    <a href={genre === "M" ? image.reglement1 : image.reglement2}>
                      {" "}
                      <BsBookFill /> Règlement
                    </a>
                  </div>
                ) : (
                  <>
                    <div className="modal-content-button">
                      <a href={image.reglement1}>
                        {" "}
                        <BsBookFill /> Règlement
                      </a>
                    </div>
                    <div className="modal-content-button">
                      <a href={image.reglement2}>
                        {" "}
                        <BsBookFill /> Qualification
                      </a>
                    </div>
                  </>
                )}
                <div className="modal-genre">
                  <button onClick={handleClose}> Fermer</button>
                </div>
              </div>
            </Modal>
          </React.Fragment>
        );
      })}

      {images.map((image) => (
        <div
          className="sports-informations"
          style={{ display: isShowCard === image.id ? "flex" : "none" }}
        >
          <div className="sports-informations-card">
            <div className="close" onClick={HideCard}>
              <AiFillCloseCircle />
            </div>
            <div className="sports-informations-title">
              <h3> {image.title}</h3>
            </div>
            <div className="sports-informations-content">
              <div className="sports-informations-description">
                <h4> Description</h4>
                {image.sportFM === 1 && image.id !== 5 ? (
                  <div>
                    <div className="sports-informations-2">
                      <h3> Masculin</h3>
                      <p>{image.description}</p>
                    </div>
                    <div className="sports-informations-2">
                      <h3> Féminin</h3>
                      <p>{image.description2}</p>
                    </div>
                  </div>
                ) : (
                  <p>{image.description}</p>
                )}
              </div>
              <div className="sports-informations-contact">
                <h4> Contact</h4>
                {image.sportFM === 1 && image.id !== 5 ? (
                  <div className="sports-informations-2">
                    <h3> Masculin</h3>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p>{image.contact}</p>
                      <p>{image.numero}</p>
                      <p>{image.mail}</p>
                    </div>
                    <h3> Féminin</h3>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p>{image.contact2}</p>
                      <p>{image.numero2}</p>
                      <p>{image.mail2}</p>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p>{image.contact}</p>
                    <p>{image.numero}</p>
                    <p>{image.mail}</p>
                  </div>
                )}
              </div>
              <div className="sports-informations-reglement">
                {image.sportFM === 1 && image.id !== 5 ? (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <a href={image.reglement1}>
                      {" "}
                      <BsBookFill /> Règlement Masculin
                    </a>
                    <a href={image.reglement2}>
                      {" "}
                      <BsBookFill /> Règlement Féminin
                    </a>
                  </div>
                ) : image.id === 5 ? (
                  <div>
                    <a href={image.reglement1}>
                      {" "}
                      <BsBookFill /> Règlement
                    </a>
                    <a href={image.reglement2}>
                      {" "}
                      <BsBookFill /> Qualification
                    </a>
                  </div>
                ) : (
                  <a href={image.reglement1}>
                    {" "}
                    <BsBookFill /> Règlement
                  </a>
                )}
              </div>
            </div>
            <div className="sports-informations-close">
              <button className="image-button black-color" onClick={HideCard}>
                Fermer
              </button>
            </div>
          </div>
        </div>
      ))}

      <Footer />
    </div>
  );
};

export default Sports;
